import MachineBrandWrapper from '../../components/calculation-form/components/form-items/machine-brands-wrapper'
import { validateMachine } from '../../helpers/validators'
import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const machineNameColumn: CalculationColumn = {
    dataIndex: ['machine', 'name'],
    relationPath: ['machine'],
    title: 'Станок',
    width: 70,
    editable: true,
    FormItem: <MachineBrandWrapper />,
    validator: validateMachine,
    onCell: onAnyStandardCell,
    render: renderCalcPos(r => r.machine?.name.split(' ')[0]),
}
